// video-reviews.js
// Handles: per-video autoplay preview, click-to-play, and the
// centered mobile lightbox. Scoped per-section so multiple
// instances of the section on one page won't conflict.

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.video-reviews').forEach(initVideoReviews);
});

// Support sections added later via the theme editor (no full reload)
document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('.video-reviews');
  if (section) initVideoReviews(section);
});

function initVideoReviews(root){
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';

  const cards = Array.from(root.querySelectorAll('.video-card'));
  const lightbox = root.querySelector('[data-lightbox]');
  const lbVideo = lightbox ? lightbox.querySelector('video') : null;
  const lbClose = lightbox ? lightbox.querySelector('.lb-close') : null;

  function isMobile(){
    return window.matchMedia('(max-width:700px)').matches;
  }

  function startPreview(card){
    const vid = card.querySelector('.card-video');
    if (!vid || card.classList.contains('is-playing')) return;
    vid.muted = true;
    vid.loop = true;
    vid.controls = false;
    card.classList.add('video-active');
    vid.play().catch(() => {});
  }

  function stopPreview(card){
    const vid = card.querySelector('.card-video');
    if (!vid || card.classList.contains('is-playing')) return;
    vid.pause();
    vid.currentTime = 0;
    card.classList.remove('video-active');
  }

  // Autoplay muted preview only while the card is actually visible
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const card = entry.target;
      const vid = card.querySelector('.card-video');
      if (!vid || vid.dataset.autoplay !== 'true') return;

      if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
        startPreview(card);
      } else {
        stopPreview(card);
      }
    });
  }, { threshold: [0, 0.6, 1] });

  cards.forEach((card) => observer.observe(card));

  cards.forEach((card) => {
    const btn = card.querySelector('.play-btn');
    const closeBtn = card.querySelector('.close-btn');
    const vid = card.querySelector('.card-video');
    if (!btn || !vid) return;

    btn.addEventListener('click', () => {
      if (isMobile() && lightbox && lbVideo) {
        openLightbox(vid.currentSrc || vid.src);
      } else {
        playInline(card, vid);
      }
    });

    if (closeBtn){
      closeBtn.addEventListener('click', () => closeInline(card, vid));
    }

    vid.addEventListener('ended', () => closeInline(card, vid));
  });

  function playInline(card, vid){
    card.classList.add('is-playing', 'video-active');
    vid.muted = false;
    vid.loop = false;
    vid.controls = true;
    vid.play().catch(() => {});
  }

  function closeInline(card, vid){
    card.classList.remove('is-playing', 'video-active');
    vid.pause();
    vid.controls = false;
    vid.currentTime = 0;
  }

  function openLightbox(src){
    if (!src) return;
    lbVideo.src = src;
    lightbox.classList.add('open');
    lbVideo.currentTime = 0;
    lbVideo.muted = false;
    lbVideo.play().catch(() => {});
  }

  function closeLightbox(){
    if (!lbVideo) return;
    lbVideo.pause();
    lbVideo.removeAttribute('src');
    lbVideo.load();
    lightbox.classList.remove('open');
  }

  if (lbClose) lbClose.addEventListener('click', closeLightbox);
  if (lightbox){
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) closeLightbox();
    });
  }
}
